import { DateTime } from 'enums';
import React, { useCallback, useImperativeHandle, useMemo, useRef, useState, forwardRef } from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { formatDate, parseDate } from 'react-day-picker/moment';
import styles from './date-picker.module.scss';
import { Calendar } from 'images';
import Image from '../image/image';
import { useMount } from 'hooks';
import moment from 'moment';
import classNames from 'classnames';

const DatePicker = ({ value, name, onChange, minDate = null, disabled, disableFrom, className, isCurrentDateMax }, ref) => {
  const [sd, setStartDate] = useState();
  const [dirty, setDirty] = useState(false);

  const startDate = useMemo(() => {
    if (value) {
      return value?.startDate;
    }
    return sd;
  }, [sd, value]);

  useImperativeHandle(ref, () => ({
    clearValue: () => {
      setStartDate(null);
      setDirty(false);
    }
  }));

  const startDateRef = useRef();

  const modifiers = useMemo(() => {
    return { start: startDate };
  }, [startDate]);

  const changeCb = useCallback(
    (value) => {
      setDirty(true);
      if (onChange) {
        return onChange(name, { value, dirty });
      }
    },
    [name, onChange, dirty]
  );

  const changeStartDateCb = useCallback(
    (start) => {
      setStartDate(start);
      if (dirty) {
        startDateRef.current.getInput().blur();
      }
      changeCb({
        startDate: new Date(moment(start).set({ hour: 0, minute: 0, second: 0 }).format('YYYY/MM/DD 00:00:00'))
      });
    },
    [changeCb, dirty]
  );

  useMount(() => {
    startDateRef.current.input.readOnly = true;
  });

  return (
    <div
      className={classNames(className, styles.inputFromTo, {
        [`${styles.disabled}`]: disabled
      })}
    >
      <div className={styles.startDate}>
        <DayPickerInput
          ref={startDateRef}
          value={startDate}
          placeholder="Select Date"
          format={DateTime.A}
          disabled={disabled}
          formatDate={formatDate}
          parseDate={parseDate}
          dayPickerProps={{
            selectedDays: [startDate, { from: startDate }],
            modifiers,
            disabledDays: { after: isCurrentDateMax ? moment().endOf('day').toDate() : null, before: minDate },
            numberOfMonths: 2
          }}
          onDayChange={changeStartDateCb}
          inputProps={{ disabled: disableFrom || disabled }}
        />
      </div>

      <Image className={styles.icon} src={Calendar} />
    </div>
  );
};

export default forwardRef(DatePicker);
